import React from 'react';
import { useLocation } from '@reach/router';
import styled, { css } from 'styled-components';
import Carousel from '@components/shared/Carousel';
import ArticleItemCarousel from '@components/vitals/ArticleItemCarousel';
import { Article, CustomArticleData } from '@contracts';
import { pageIsAdsPage } from '@utils/helpers';

interface Props {
  background?: string;
  articles: Array<Article | Article<CustomArticleData>>;
  carouselRef?: React.Ref<null>;
  onlyMobileDesign?: boolean;
}

const carouselOptions = { initialIndex: 0, draggable: true };

const ArticleCarousel: React.FC<Props> = ({ articles, carouselRef, onlyMobileDesign, background }) => {
  const location = useLocation();
  const hiddenPaths = [
    '/1/' // usMetaHomeURL
  ];
  const isPathIncluded = hiddenPaths.some((path) => location?.pathname.includes(path));
  const isPageForAds = pageIsAdsPage(location.pathname);
  const hideCBDWords = !location || isPathIncluded || isPageForAds;

  if (articles.length === 0) {
    return null;
  }

  return (
    <Container $background={background} $onlyMobileDesign={onlyMobileDesign}>
      <Carousel ref={carouselRef} options={carouselOptions}>
        {articles.map((article) => {
          if (!article || ('category' in article.data && article.data.category.slug === 'cbd' && hideCBDWords)) return null;
          return <ArticleItemCarousel key={article.id} article={article} onlyMobileDesign={onlyMobileDesign} />;
        })}
      </Carousel>
    </Container>
  );
};

export default ArticleCarousel;

const ContainerMobileCss = css`
  .carousel {
    display: flex;
    flex-wrap: no-wrap;
    justify-content: flex-start;
    padding-left: 32px;
  }
`;

const Container = styled.div<{ $background?: string; $onlyMobileDesign?: boolean }>`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  background: ${({ $background }) => $background || 'transparent'};

  .flickity-viewport {
    overflow: visible;
  }

  .carousel:after {
    content: 'flickity';
    display: none; /* hide :after */
  }

  ${(props) => props.$onlyMobileDesign && ContainerMobileCss}

  @media (max-width: 1024px) {
    ${ContainerMobileCss}
  }

  @media (max-width: 800px) {
    .carousel {
      padding-bottom: 24px;
    }
  }
`;
